import { differenceInYears } from 'date-fns-v3';

export function calculateAge(
  dateOfBirth: string | number,
  date: string | number = Date.now(),
) {
  const age = differenceInYears(date, dateOfBirth);
  return age;
}
